import classNames from "classnames";
import { Fragment } from "react";
import { Typography } from "@mui/material";
import { T } from "components/util/t";
import { makeStyles } from "components/providers/makeStyles";
import { TeamMembersRow } from "./TeamMembersRow";

const useStyles = makeStyles((theme) => ({
    grid: {
        display: "grid",
        gridTemplateColumns: "auto 1fr",
    },
    heading: {
        textTransform: "uppercase",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        paddingBottom: theme.spacing(1),
        "&:nth-of-type(even)": {
            paddingLeft: theme.spacing(2),
        }
    },
    row: {
        minHeight: theme.spacing(6),
        borderBottom: `1px solid ${theme.palette.border.main}`,
        display: "flex",
        alignItems: "center",
        "&:nth-of-type(even)": {
            paddingLeft: theme.spacing(2),
        }
    },
    start: {
        justifyContent: "center"
    },
    lastRow: {
        border: 0
    }
}));

export const TeamMembersList = ({ teamConfig, members, onAthleteRemoved, onUpdateTeamMemberRole, renderTeamMembersSelector, teamRoles, assignedRoles, disabled, athletesHeading = "Athlete" }) => {
    const classes = useStyles();

    return (
        <div className={classes.grid}>
            <Typography variant="label2" color="textSecondary" className={classes.heading}><T>Start</T></Typography>
            <Typography variant="label2" color="textSecondary" className={classes.heading}><T>{athletesHeading}</T></Typography>

            {[...new Array(teamConfig.athletesPerTeam)].map((_, index) => (
                <Fragment key={index}>
                    <div className={classNames(classes.row, classes.start, { [classes.lastRow]: index + 1 === teamConfig.athletesPerTeam })}>{index + 1}</div>
                    <div className={classNames(classes.row, { [classes.lastRow]: index + 1 === teamConfig.athletesPerTeam })}>
                        <TeamMembersRow
                            index={index}
                            member={members[index]}
                            onAthleteRemoved={onAthleteRemoved}
                            renderTeamMembersSelector={renderTeamMembersSelector}
                            teamRoles={teamRoles}
                            onUpdateTeamMemberRole={onUpdateTeamMemberRole}
                            assignedRoles={assignedRoles}
                            disabled={disabled}
                        />
                    </div>
                </Fragment>
            ))}
        </div>
    );
};
